export default __webpack_public_path__ + "static/media/ControlVisio.e546e897.png";